import { useEffect, useState } from "@wordpress/element";
import useSWR from "swr";
import { fetcher } from "../fetcher";
import qs from "qs";
import { Article, Skeleton } from "../articles/components/article";

function get() {
	return qs.parse(window.location.search, { ignoreQueryPrefix: true });
}

export function Block({ node }) {
	const [params, set] = useState(get());

	useEffect(() => {
		window.addEventListener("params_update", () => set(get()));
	}, []);

	const encoded = qs.stringify(params, { addQueryPrefix: true });
	const url = `/wp-json/steam-api/articles${encoded}`;

	const { isLoading, data } = useSWR(url, fetcher, {
		keepPreviousData: true,
	});

	return (
		<>
			{isLoading && !data && [...Array(8)].map((_, i) => <Skeleton key={i} />)}

			{data && data.content.map((i) => <Article key={i.ID} article={i} />)}
		</>
	);
}
